import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { addZero } from 'pz-unit/lib/util';

class TimeBlock {
    public blockName: string;
    public blockValue: Date;
    public startBlock?: boolean;
    public betweenBlock?: boolean;
}

class TimeRange {
    public startTime: number;
    public endTime: number;
}

@Component({
    selector: 'pz-multi-time-range',
    templateUrl: './multi-time-range.component.html',
    styleUrls: ['./multi-time-range.component.scss'],
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: MultiTimeRangeComponent, multi: true}]
})
export class MultiTimeRangeComponent implements OnInit, AfterViewInit, ControlValueAccessor {
    public timeBlockCount = 49;
    public timeBlock: TimeBlock[] = [];
    public selectStart: boolean;
    public startIndex: number;
    public endIndex: number;
    public canClear: boolean;
    public _selectRange: TimeRange[] = [];
    private onChangeFn: (value: TimeRange[] | null) => void;
    private onTouchedFn: () => void;

    public set selectRange(value: TimeRange[]) {
        this._selectRange = value;
        this.canClear = !(value && value.length > 0);
        this.onChangeFn(this.outPut(value));
    }

    public get selectRange(): TimeRange[] {
        return this._selectRange;
    }

    public constructor() {
        //
    }
    public ngOnInit(): void {
        this.creatBlock();
    }

    public ngAfterViewInit(): void {
        //
    }

    public init() {
        if (this.selectRange.length !== 0) {
            this.selectRange.map(x => {
                this.timeBlock[x.startTime].startBlock = true;
                this.timeBlock[x.endTime].startBlock = true;
                for (let i = x.startTime; i !== x.endTime; i < x.endTime ? i++ : i--) {
                    this.timeBlock[i].betweenBlock = true;
                }
            });
        } else {
            this.timeBlock.map(x => {
                x.startBlock = false;
                x.betweenBlock = false;
            });
        }
    }

    public writeValue(val): void {
        this.inPut(val);
    }

    public registerOnChange(fn: any): void {
        this.onChangeFn = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouchedFn = fn;
    }

    public creatBlock() {
        const blocks: TimeBlock[] = [];
        const date: Date = new Date(0, 0, 0, 0, 0);
        for (let i = 0; i < this.timeBlockCount; i++) {
            const target = new Date(new Date(date).setMinutes(date.getMinutes() + 30 * i));
            const hours = addZero(i > 47 ? 24 : target.getHours());
            const minute = addZero(target.getMinutes());
            blocks.push({
                blockName: `${hours}:${minute}`,
                blockValue: target,
            });
        }
        this.timeBlock = blocks;
    }

    public selectBlock(timeBlock: TimeBlock, i: number) {
        const isInRange = this.getIndex(i);
        if (!this.selectStart) {
            if (isInRange) {
                this.timeBlock.map(x => {
                    x.startBlock = false;
                    x.betweenBlock = false;
                });
                this._selectRange = this._selectRange.filter(x => !(x.startTime <= i && i <= x.endTime));
                this.init();
            }
            this.startIndex = i;
            timeBlock.startBlock = true;
        } else {
            if (isInRange !== null) {
                this.endIndex = isInRange;
                this.selectRange = this.selectRange.filter(x => !(x.startTime <= i && i <= x.endTime));
            } else {
                this.endIndex = i;
                timeBlock.startBlock = true;
            }
            const addRange = {
                startTime: this.startIndex < this.endIndex ? this.startIndex : this.endIndex,
                endTime: this.startIndex > this.endIndex ? this.startIndex : this.endIndex
            };
            this.selectRange = [...this.selectRange.filter(z =>
                !(z.startTime >= addRange.startTime && z.endTime <= addRange.endTime)), addRange];
            this.timeBlock.map(x => {
                x.startBlock = false;
                x.betweenBlock = false;
            });
            this.init();
            this.endIndex = this.startIndex = undefined;
        }
        this.selectStart = !this.selectStart;
    }

    public getIndex(index): number | null {
        let res;
        if (this.selectRange.length !== 0) {
            if (!this.selectRange.some(x => x.startTime <= index && index <= x.endTime)) {
                return null;
            } else {
                if (this.startIndex) {
                    const range = this.selectRange.find(x => x.startTime <= index && index <= x.endTime);
                    if (this.startIndex < range.startTime) {
                        return range.endTime;
                    }
                    if (this.startIndex > range.endTime) {
                        return  range.startTime;
                    }
                } else {
                    return  1;
                }
            }
        } else {
            res = null;
        }
        return res;
    }

    public checkClass(time: TimeBlock): string {
        return `${time.startBlock ? ' point' : ''}${time.betweenBlock ? ' between' : ''}`;
    }

    public hover(i: number) {
        if (this.selectStart) {
            this.timeBlock.map(x => {
                x.betweenBlock = false;
            });
            this.init();
            this.timeBlock[this.startIndex].startBlock = true;
            for (let t = i; t !== this.startIndex; (i > this.startIndex ? t-- : t++)) {
                this.timeBlock[t].betweenBlock = true;
            }
        }
    }

    public inPut(value) {
        if (value) {
            const inputData = JSON.parse(value);
            this._selectRange = inputData.map(x => {
                return {
                    startTime: x[0] * 2 + (x[1] >= 30 ? 1 : 0),
                    endTime: x[2] * 2 < 47 ? x[2] * 2 + (x[3] >= 30 ? 1 : 0) : 48,
                };
            });
        } else {
            this._selectRange = [];
        }
        this.init();
    }

    public view() {
        return this.selectRange.map(x => {
            return [
                `${addZero(new Date(this.timeBlock[x.startTime].blockValue).getHours())}:${
                    addZero(new Date(this.timeBlock[x.startTime].blockValue).getMinutes())}-${
                    addZero(new Date(this.timeBlock[x.endTime].blockValue).getHours())}:${
                    addZero(new Date(this.timeBlock[x.endTime].blockValue).getMinutes())}`,
            ];
        });
    }

    public outPut(value) {
        return value.map(x => {
            return [
                Math.floor(x.startTime / 2), x.startTime % 2 > 0 ? 30 : 0,
                Math.floor(x.endTime / 2), x.endTime % 2 > 0 ? 30 : 0,
            ];
        });
    }

    public clearValue(e) {
        e.preventDefault();
        this.selectRange = [];
        this.init();
    }
}
